import { defineComponent as _defineComponent } from 'vue'
import { withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import IconInfoCircle from '@/design-system/assets/icons/IconInfoCircle.vue'
import IconTimeLine from '@/design-system/assets/icons/IconTimeLine.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoButton',
  props: {
    state: { type: Boolean }
  },
  emits: ['click'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit


function onClick(event?: Event, preventDefault?: boolean) {
  if (event && preventDefault) event.preventDefault() // Prevent space bar scrolling
  emit('click')
}

return (_ctx: any,_cache: any) => {
  return (!_ctx.state)
    ? (_openBlock(), _createBlock(IconInfoCircle, {
        key: 0,
        class: "info",
        role: "button",
        tabindex: "0",
        onClick: onClick,
        onKeydown: [
          _withKeys(onClick, ["enter"]),
          _cache[0] || (_cache[0] = _withKeys((event) => onClick(event, true), ["space"]))
        ]
      }))
    : (_openBlock(), _createBlock(IconTimeLine, {
        key: 1,
        class: "info",
        role: "button",
        tabindex: "0",
        onClick: onClick,
        onKeydown: [
          _withKeys(onClick, ["enter"]),
          _cache[1] || (_cache[1] = _withKeys((event) => onClick(event, true), ["space"]))
        ]
      }))
}
}

})